import * as THREE from 'three';
import * as TextCreation from '../TextCreation';
import { registerScenePolicy } from '../../../core/ScenePolicies';
import { World } from './World';
import { addWorldBoundarySphere } from './WorldBuilderHelpers';
function titleCase(slug) {
    if (!slug)
        return '';
    return slug
        .split('-')
        .filter(Boolean)
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}
function buildDynamicWorld(context) {
    const { scene, world } = context;
    scene.background = new THREE.Color(0xefedfa);
    scene.fog = new THREE.Fog(0xffffff, 0, 32000);
    const ambient = new THREE.HemisphereLight(0xf4f6ff, 0xc8d4ff, 0.8);
    ambient.name = 'dynamicWorldAmbient';
    scene.add(ambient);
    const keyLight = new THREE.DirectionalLight(0xffffff, 0.75);
    keyLight.position.set(1800, 3200, -1600);
    keyLight.name = 'dynamicWorldKeyLight';
    scene.add(keyLight);
    const fillLight = new THREE.DirectionalLight(0xf8fcff, 0.4);
    fillLight.position.set(-1400, 2200, 1800);
    fillLight.name = 'dynamicWorldFillLight';
    scene.add(fillLight);
    const label = TextCreation.createTextSprite(world.label, 3.2, new THREE.Vector3(0, 320, 0));
    label.name = 'dynamicWorldLabel';
    scene.add(label);
    const subtitle = TextCreation.createTextSprite(`World: ${world.slug}`, 1.8, new THREE.Vector3(0, 220, 0));
    subtitle.name = 'dynamicWorldSlug';
    scene.add(subtitle);
    const radius = 11000;
    registerScenePolicy(world.sceneName, { radius }); //TODO. right here, we need to ensure the doWOrldFloor part is disabled if the respective world does not specify it.
    addWorldBoundarySphere(scene, radius, { color: 0x5f7be9, opacity: 0.26, segments: 64 });
}
export function createDynamicWorld(slug) {
    const label = titleCase(slug) || 'Custom World';
    return new World({
        slug,
        label,
        build: buildDynamicWorld,
    });
}
